ConfirmationRow = App.loadClass 'grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationRow'

class exports.ConfirmationPlantingController extends ConfirmationRow
    constructor: (@scope, @transitions, @state, @generate, @data, @loader, @window, @modal) ->
        super(@scope, @transitions, @state, @generate, @data, @loader, @window, @modal)
        @scope.resize = 0
        @scope.tab = 'planting'
        # load the data for select boxes
        @loadSelectData()
        @scope.show_ingredion_column = false
        @scope.required_col_span = 4
        # functions
        @scope.updateChildrenYear = @updateChildrenYear
        @scope.updateChildrenCrop = @updateChildrenCrop
        @scope.getSeedCompaniesByCrop = @getSeedCompaniesByCrop
        @scope.updateChildrenNumberOfProducts = @updateChildrenNumberOfProducts
        @scope.updateChildrenSeedCompanies = @updateChildrenSeedCompanies
        @scope.updateChildrenProduct = @updateChildrenProduct
        @scope.getProductsBySeedCompany = @getProductsBySeedCompany
        @scope.clearCompanySelections = @clearCompanySelections
        @scope.clearProductSelection = @clearCompanySelections
        @scope.validateConfirmByStatus = @validateConfirmByStatus
        @scope.checkSelectionsForConfirm = @checkSelectionsForConfirm
        @scope.confirm = @confirm
        @scope.openSurveyDialog = @openSurveyDialog
        @scope.launchAddProduct = @launchAddProduct
        @scope.groupProducts = @groupProducts
        @scope.paginate = @paginate

    openSurveyDialog: (parent) =>
        dialog = @modal.open
            windowClass: 'large_dialog'
            templateUrl: 'backend/grower/maps-conversion/ingredion-survey'
            controller: 'MapsUpload.Controllers.IngredionDialogController'
            resolve:
                survey: -> parent.data.reference.ingredion_survey

        dialog.result.then (answered_survey) =>
            parent.data.reference.ingredion_survey = answered_survey
            @checkSelectionsForConfirm(parent)


    alphabeticalComparison = (a, b) ->
        # force reconfirm to show first in the list
        if a.data.status is 'Reconfirm'
            return -1
        if b.data.status is 'Reconfirm'
            return 1

        result = strnatcasecmp(a.data.status, b.data.status)

        if result is 0
            result = strnatcasecmp(a.data.reference.farmName, b.data.reference.farmName)

        if result is 0
            result = strnatcasecmp(a.data.reference.fieldName, b.data.reference.fieldName)

        if result is 0
            result = strnatcasecmp(a.data.selected.year, b.data.selected.year)

        return result


    loadSelectData: () =>
        # Array of all years from 2005 to current crop year
        @data.getAllYears().then (response) =>
            if response?.data?.status?.type is 'success'
                @scope.years = response.data.data

        # Array of crops
        @data.getCrops().then (response) =>
            if response?.data?.status?.type is 'success'
                @scope.crops = response.data.data

    loadParentData: (skip = 0, take = 10) =>
        # show loader while we get data
        @loader.overMap 'Loading...'

        # Fetch the content
        @data.getPlantingRows(skip, take).then (response) =>
            if response?.data?.status?.type is 'success'
                @scope.parents = response.data.data.rows
                # load companies and products if needed
                for parent in @scope.parents
                    parent.loading = false
                    # alias processed status
                    if parent.data.status is 'Processed'
                        parent.data.status = 'Done'

                    # scan all the rows for an ingredion field so we can show the column
                    if parent.data.reference.is_ingredion_field is true
                        @scope.show_ingredion_column = true
                        @scope.required_col_span = 5

                    for product in parent.data.fileData
                        if product.selected.crop.id
                            # get seed companies
                            @scope.getSeedCompaniesByCrop(product, product.selected.crop, false)

                        if product.selected.seedCompany.id
                            # get products
                            @scope.getProductsBySeedCompany(product, false)

                        # initialize confirm button
                        @checkSelectionsForConfirm(parent)

                # sort parents
                @scope.parents.sort(alphabeticalComparison.bind([]))

                return response.data.data.count


    checkSelectionsForConfirm: (parent) =>
        parent.disabled.confirm = true
        parent.disabled.ingredion = true
        parent.show_ingredion = false
        has_corn = false

        # ingredion specific checks
        if parent.data.reference.is_ingredion_field is true
            for product in parent.data.fileData
                break if has_corn
                has_corn = product.selected.crop? and product.selected.crop.name is 'Corn'
            parent.show_ingredion = true if has_corn

        # check all selections and ensure they are set properly
        if not parent.data.selected.year?
            parent.disabled.confirm = true
            return @determineStatus(parent)

        # check product row selections
        for product in parent.data.fileData
            if false in [product.selected.crop?.id?, @validateProductSelection(product)]
                parent.disabled.confirm = true
                return @determineStatus(parent)

        parent.disabled.ingredion = false  # if we made it this far we know all products are set

        if parent.data.reference.is_ingredion_field and parent.data.reference.ingredion_survey.for_ingredion is null
            return @determineStatus(parent)

        return @determineStatus(parent).then () =>
            # check status
            if @validateConfirmByStatus(parent)
                parent.disabled.confirm = false


    validateProductSelection: (product) =>
        # returns true if
            # seed company and product are both set
        return product.selected.seedCompany?.id? and product.selected.product?.id?


    validateConfirmByStatus: (parent) =>
        if parent.data.status in ['Processing', 'Failed', 'Done']
            parent.disabled.confirm = true
            return false

        return true

    confirm: (parent) =>
        # switch status to processing, and disable confirm button
        parent.data.status = 'Processing'
        parent.loading = true
        parent.disabled.confirm = true
        @generate.confirm(parent.parent_id, parent.data.reference.ingredion_survey).then (response) =>
            # check for unconfirmed files
            @updateTab()
